var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { keyframes } from 'styled-components';
import { getDefaultStyle } from '../helpers';
import { DEFAULT_COLOR, DEFAULT_WAI_ARIA_ATTRIBUTE } from '../type';
var dash = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n to {\n    stroke-dashoffset: 136;\n  }\n"], ["\n to {\n    stroke-dashoffset: 136;\n  }\n"])));
var Polygon = styled.polygon(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  stroke-dasharray: 17;\n  animation: ", " 2.5s cubic-bezier(0.35, 0.04, 0.63, 0.95) infinite;\n"], ["\n  stroke-dasharray: 17;\n  animation: ", " 2.5s cubic-bezier(0.35, 0.04, 0.63, 0.95) infinite;\n"])), dash);
var SVG = styled.svg(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  transform-origin: 50% 65%;\n"], ["\n  transform-origin: 50% 65%;\n"])));
var Triangle = function Triangle(_a) {
  var _b = _a.height,
    height = _b === void 0 ? 80 : _b,
    _c = _a.width,
    width = _c === void 0 ? 80 : _c,
    _d = _a.color,
    color = _d === void 0 ? DEFAULT_COLOR : _d,
    _e = _a.ariaLabel,
    ariaLabel = _e === void 0 ? 'triangle-loading' : _e,
    wrapperStyle = _a.wrapperStyle,
    wrapperClass = _a.wrapperClass,
    _f = _a.visible,
    visible = _f === void 0 ? true : _f;
  return React.createElement("div", __assign({
    style: __assign(__assign({}, getDefaultStyle(visible)), wrapperStyle),
    className: "".concat(wrapperClass),
    "data-testid": "triangle-loading",
    "aria-label": ariaLabel
  }, DEFAULT_WAI_ARIA_ATTRIBUTE), React.createElement(SVG, {
    id: "triangle",
    width: width,
    height: height,
    viewBox: "-3 -4 39 39",
    "data-testid": "triangle-svg"
  }, React.createElement(Polygon, {
    fill: "transparent",
    stroke: color,
    strokeWidth: "1",
    points: "16,0 32,32 0,32"
  })));
};
export default Triangle;
var templateObject_1, templateObject_2, templateObject_3;